import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ReactQuill from 'react-quill-new';
import {Portal_Field} from "biz9-portal-app";
import {Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import 'react-quill-new/dist/quill.snow.css';
/* -- biz9 import start -- */
import {Log} from "biz9-utility";
/* -- biz9 import end -- */
const Item_Note_Edit = (props) => {
	const [val_note,setValNote] = useState("");
    useEffect(() => {
        setValNote(props.item.note);
            },[props]);
  const set_value = (previousRange, source, editor) => {
       setValNote(editor.getHTML().trim());
  };
const update_item = () => {
        props.onItemUpdate(props.item,Field.NOTE,val_note);
    };
    const handle_submit = (event) => {
        event.preventDefault();
    };
    const modules = {
toolbar:
        [
            [{ 'header': [2, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }, { 'background': [] }],
            ['link', 'image', 'video'],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean']
        ],
    };
    return (
            <div className="settings-card">
            <div className="settings-card-head bg-light">
            <h4>Note</h4>
            </div>
            <form onSubmit={handle_submit}>
            <div className="settings-card-body">
            <div className="row">
            <div className="col-md-12">
            <div className="form-wrap mb-3" onBlur={update_item} >
            <ReactQuill value={val_note} modules={modules} theme="snow" onChange={setValNote} />
            </div>
            </div>
            </div>
            </div>
            </form>
            </div>
           );
};
export default Item_Note_Edit;
